import { render, staticRenderFns } from "./user-role-management.view.vue?vue&type=template&id=06c313a2&scoped=true"
import script from "./user-role-management.view.vue?vue&type=script&lang=ts"
export * from "./user-role-management.view.vue?vue&type=script&lang=ts"
import style0 from "./user-role-management.view.vue?vue&type=style&index=0&id=06c313a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c313a2",
  null
  
)

export default component.exports